// F19: turn the backend's default Cannes calendar (GET /default-events, engine
// shape) into editable events for one property, so you can review and change them.
import { PropertyEvent } from '../services/propertyAPI';

export function fromDefaultEvents(events: any[], propertyId: string): PropertyEvent[] {
  const now = new Date().toISOString();
  return events.map((e, i) => ({
    id: `default-${propertyId}-${e.start}-${i}`,
    property_id: propertyId,
    name: e.name,
    start_date: e.start,
    end_date: e.end,
    adr: Number(e.adr),
    occupancy_pct: Number(e.occ_pct),
    probability: Number(e.prob ?? 1),
    status: e.status || 'EXAMPLE',
    source: e.source,
    created_at: now,
  } as PropertyEvent));
}
